import { render, staticRenderFns } from "./ChannelTypeBreakdownModal.vue?vue&type=template&id=2789e37e&"
import script from "./ChannelTypeBreakdownModal.vue?vue&type=script&lang=js&"
export * from "./ChannelTypeBreakdownModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports